

































import { Component, Prop, Watch, Vue } from 'vue-property-decorator'
import { ListType } from '@/util/types'
import { getTree } from './data'
import { Filter, FilterTree } from './types'
import Select from './select.vue'
import { MapType } from '@/util/types'
import { walkTree } from '@/fn/tree'

@Component
export default class FilterComp extends Vue {
  @Prop({ type: Number, default: 0 }) type!: ListType

  @Prop({ type: Object, default: () => ({}) }) value!: MapType<number>

  @Prop({ type: Boolean, default: false }) hasPlaceholder!: boolean

  @Prop({ type: Boolean, default: true }) isCloudSource!: boolean

  keyword: string = this.$store.state.searchQuery.key_word || ''

  listType = ListType

  doc: any

  filterTree: FilterTree | null = null

  get filterList(): FilterTree[] {
    if (!this.filterTree) {
      return []
    }
    return this.filterTree.shownFilterList
  }

  get i18n() {
    const value = this.$t('login')
    return value as any
  }

  get isEnLang() {
    return this.$i18n.locale == 'en'
  }

  created() {
    this.doc = window.document
    this.getFilterTree()
  }

  getFilterTree() {
    getTree(this.type, this).then((tree: FilterTree | null) => {
      this.filterTree = this.getCursorValue(tree)
    })
  }

  handleSelect(filter: FilterTree, value: number) {
    filter.select(value)
    this.search()
  }

  handleEnter(e: any) {
    e.preventDefault()
    this.search()
  }

  emptyKeyword() {
    this.keyword = ''
    this.search()
  }

  search() {
    if (!this.filterTree) {
      return
    }
    const query = this.filterTree.query
    this.$emit('change', { ...query, key_word: this.keyword })
  }

  reset() {
    this.keyword = ''
    this.resetFilter()
  }

  resetFilter() {
    if (!this.filterTree) {
      return
    }
    this.filterTree.reset()
  }

  getCursorValue(tree: FilterTree | null) {
    if (!tree) {
      return tree
    }
    const query: any = this.$store.state.searchQuery
    tree.children.map(it => {
      if (query[it.key]) {
        tree.cursorValue = query[it.key] ? query[it.key] : it.cursorValue
      }
      if (it.children.length > 0) {
        this.getCursorValue(it)
      }
      return it

    })
    return tree

  }
}
